import React, { useState, useContext } from 'react';
import Sidebar from './Sidebar';
import ContextStates from '../../context/ContextStates';
import authContext from '../../context/auth/authContext';
//import ContextEstados from '../../context/ContextEstados';
import { AiFillHome, AiOutlineBarChart } from "react-icons/ai"
import { FaTruck, FaTools, FaToolbox, FaUserAlt, FaListUl, FaCalendarCheck, FaHandPaper, FaUserCog } from "react-icons/fa"
import { FiMenu } from "react-icons/fi"
import { GrClose } from "react-icons/gr"
import { LuBox } from "react-icons/lu"
import { MdRequestQuote, MdDeliveryDining, MdBrandingWatermark } from "react-icons/md"
import { MdOutlineAttachMoney } from "react-icons/md"
import { TbCalendarDollar, TbTruckDelivery } from "react-icons/tb"
import { FaCashRegister } from "react-icons/fa"
import { IoIosPricetags, IoMdExit } from "react-icons/io"
import { FaPercent, FaSitemap, FaQrcode } from "react-icons/fa"
import { FaUsers } from "react-icons/fa"
import { FaHouseUser } from "react-icons/fa"
import { FaChartBar } from "react-icons/fa"
import { FaUsersCog } from "react-icons/fa"
import { BsFillGearFill, BsPuzzle } from "react-icons/bs"
import { HiLocationMarker } from "react-icons/hi"
import { IoIosPeople } from "react-icons/io"
import { VscChecklist } from "react-icons/vsc"
import { ImTree } from "react-icons/im";

import { Link, useNavigate } from 'react-router-dom';

/**
 * Ejemplo de uso del componente Sidebar
 * 
 * Este componente muestra cómo integrar el Sidebar en tu aplicación
 * con un botón toggle y contenido personalizado
 */
const SideBarExt = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const { roles, setIdUsuario, setCliente, setMail } = useContext(ContextStates);
    const { cerrarSesion } = useContext(authContext);
    const navigate = useNavigate();

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };


    const logOut = () => {
        console.log("cerrar sesion");
        let tipoUser = localStorage.getItem('anpvp_tp');
        if (tipoUser === '1') {
            setIdUsuario(0)
        }
        else {
            setCliente(0)
        }

        // Limpiar el mail del contexto
        setMail(null);

        // Cerrar sesión (limpia localStorage y estado de auth)
        cerrarSesion();

        // Redirigir a la página de login
        navigate('/');
    }

    return (
        <div className="app-container">
            {/* Botón para abrir el sidebar */}
            <button
                onClick={toggleSidebar}
                style={{
                    position: 'fixed',
                    top: '1rem',
                    left: '1rem',
                    zIndex: 997,
                    padding: '0.75rem',
                    backgroundColor: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    fontSize: '1rem',
                    fontWeight: '500',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                    transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
            >
                <FiMenu size={20} />
                Menú
            </button>

            {/* Sidebar Component */}
            <Sidebar
                isOpen={isSidebarOpen}
                onClose={closeSidebar}
                width="320px"
                showBackdrop={true}
                position="left"
            >
                {/* Header del sidebar */}
                <div className="sidebar-header">
                    <h2 className="sidebar-title">Mi Aplicación</h2>
                    <button
                        className="sidebar-close-btn"
                        onClick={closeSidebar}
                        aria-label="Cerrar menú"
                    >
                        <GrClose />
                    </button>
                </div>


                {/* Contenido del sidebar - Menú de navegación */}
                <nav>
                    <ul className="sidebar-menu">

                        <li className="sidebar-menu-item">
                            <Link to="/admin/" className="sidebar-menu-link active">
                                <span className="sidebar-menu-icon">
                                    <AiFillHome />
                                </span>
                                Inicio
                            </Link>
                        </li>
                        {/* Divider */}
                        <div className="sidebar-divider" />
                        <li className="sidebar-menu-item">
                            <Link to="/admin/productos" className="sidebar-menu-link">
                                <span className="sidebar-menu-icon">
                                    <LuBox />
                                </span>
                                Productos
                            </Link>
                        </li>


                        <li className="sidebar-menu-item">
                            <Link to="/admin/marcas" className="sidebar-menu-link">
                                <span className="sidebar-menu-icon">
                                    <MdBrandingWatermark />
                                </span>
                                Marcas
                            </Link>
                        </li>
                        <li className="sidebar-menu-item">
                            <Link to="/admin/rubros" className="sidebar-menu-link">
                                <span className="sidebar-menu-icon">
                                    <FaSitemap />
                                </span>
                                Rubros
                            </Link>
                        </li>
                        {roles.includes("1") && (
                            <>
                                {/* Divider */}
                                <div className="sidebar-divider" />
                                <li className="sidebar-menu-item">
                                    <Link to="/admin/ventas" className="sidebar-menu-link">
                                        <span className="sidebar-menu-icon">
                                            <MdOutlineAttachMoney />
                                        </span>
                                        Ventas
                                    </Link>
                                </li>
                                <li className="sidebar-menu-item">
                                    <Link to="/admin/repartos" className="sidebar-menu-link">
                                        <span className="sidebar-menu-icon">
                                            <TbTruckDelivery />
                                        </span>
                                        Repartos
                                    </Link>
                                </li>
                                <li className="sidebar-menu-item">
                                    <Link to="/admin/compras" className="sidebar-menu-link">
                                        <span className="sidebar-menu-icon">
                                            <TbCalendarDollar />
                                        </span>
                                        Compras
                                    </Link>
                                </li>
                                <li className="sidebar-menu-item">
                                    <Link to="/admin/jornadas" className="sidebar-menu-link">
                                        <span className="sidebar-menu-icon">
                                            <FaCashRegister />
                                        </span>
                                        Jornadas
                                    </Link>
                                </li>
                                <li className="sidebar-menu-item">
                                    <Link to="/admin/precios" className="sidebar-menu-link">
                                        <span className="sidebar-menu-icon">
                                            <IoIosPricetags />
                                        </span>
                                        Precios
                                    </Link>
                                </li>
                                <li className="sidebar-menu-item">
                                    <Link to="/admin/promociones" className="sidebar-menu-link">
                                        <span className="sidebar-menu-icon">
                                            <FaPercent />
                                        </span>
                                        Promociones
                                    </Link>
                                </li>
                                <li className="sidebar-menu-item">
                                    <Link to="/admin/clientes" className="sidebar-menu-link">
                                        <span className="sidebar-menu-icon">
                                            <FaUsers />
                                        </span>
                                        Clientes
                                    </Link>
                                </li>
                                <li className="sidebar-menu-item">
                                    <Link to="/admin/proveedores" className="sidebar-menu-link">
                                        <span className="sidebar-menu-icon">
                                            <FaHouseUser />
                                        </span>
                                        Proveedores
                                    </Link>
                                </li>
                                <li className="sidebar-menu-item">
                                    <Link to="/admin/reportes" className="sidebar-menu-link">
                                        <span className="sidebar-menu-icon">
                                            <FaChartBar />
                                        </span>
                                        Reportes
                                    </Link>
                                </li>
                                <li className="sidebar-menu-item">
                                    <Link to="/admin/adminusuarios" className="sidebar-menu-link">
                                        <span className="sidebar-menu-icon">
                                            <FaUsersCog />
                                        </span>
                                        Administrar usuarios
                                    </Link>
                                </li>
                                <li className="sidebar-menu-item">
                                    <Link to="/admin/configuracion" className="sidebar-menu-link">
                                        <span className="sidebar-menu-icon">
                                            <BsFillGearFill />
                                        </span>
                                        Configuración
                                    </Link>
                                </li>
                            </>
                        )}
                        {/* Divider */}

                    </ul>

                    {/* Divider */}
                    <div className="sidebar-divider" />

                    <ul className="sidebar-menu">
                        <li className="sidebar-menu-item">
                            <Link to="/perfil" className="sidebar-menu-link">
                                <span className="sidebar-menu-icon">
                                    <FaUserAlt />
                                </span>
                                Mi Perfil
                            </Link>
                        </li>
                    </ul>
                    <ul className="sidebar-menu">
                        <li className="sidebar-menu-item">
                            <Link to="/" className="sidebar-menu-link">
                                <span className="sidebar-menu-icon">
                                    <IoMdExit />
                                </span>
                                <p className='text-green-500'>
                                    Volver a Ventas
                                </p>
                            </Link>
                        </li>
                    </ul>
                </nav>

                {/* Footer del sidebar */}
                <div className="sidebar-footer">
                    <button
                        style={{
                            width: '100%',
                            padding: '0.75rem',
                            backgroundColor: '#ef4444',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '0.95rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#dc2626'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#ef4444'}
                        onClick={() => logOut()}
                    >
                        Cerrar Sesión
                    </button>
                </div>
            </Sidebar>
        </div >
    );
};

export default SideBarExt;
